import * as React from 'react';
import { SerializedStyles, css } from '@emotion/react';
import { useTheme } from '@veneer/theme';

type HelperTextStyles = {
  root: {
    base: SerializedStyles;
    disabled: SerializedStyles;
    visible: SerializedStyles;
  };
  icon: {
    base: SerializedStyles;
    disabled: SerializedStyles;
    error: SerializedStyles;
    info: SerializedStyles;
    success: SerializedStyles;
  };
  message: SerializedStyles;
};

const useStyles = (): HelperTextStyles => {
  const theme = useTheme();

  return React.useMemo(() => {
    return {
      root: {
        base: css({
          color: theme.color.foreground.default,
          display: 'none',
          gap: theme.layout.size1,
          alignItems: 'center',
          ...theme.typography.captionRegular,
        }),
        visible: css({
          display: 'flex',
        }),
        disabled: css({
          color: theme.color.foreground.disabled,
        }),
      },
      icon: {
        base: css({
          height: theme.orbitalSix,
          alignSelf: 'flex-start',
          alignItems: 'center',
          display: 'inline-flex',
          justifyContent: 'center',
          maxWidth: theme.orbitalSix,
        }),
        info: css({
          color: theme.color.foreground.light,
        }),
        error: css({
          color: theme.color.negative.base.default,
        }),
        success: css({
          color: theme.color.positive.base.default,
        }),
        disabled: css({
          color: theme.color.foreground.disabled,
        }),
      },
      message: css({
        padding: '2px 0',
        wordBreak: 'break-word',
      }),
    };
  }, [theme]);
};

export default useStyles;
